import { absolutePath } from "./absolutePath";

export const integrations = {
  connections: {
    create: () => absolutePath("integrations/connections"),
    index: () => absolutePath("integrations/connections"),
    show: (id: number) => absolutePath(`integrations/connections/${id}`),
    destroy: (id: number) => absolutePath(`integrations/connections/${id}`),
    connect: (id: number) =>
      absolutePath(`integrations/connections/${id}/connect`),
  },
};
